<template>
    <section class="text-center page-not-found">
        <h1>Sorry, This Page Not Found (Try to Enter Other Link)</h1>
        <button class="redirect-button btn-danger" @click="redirectToHomePage">Click For Redirect To Home Page</button>
    </section>
</template>

<style lang="scss" scoped>

.page-not-found{
    display: grid;
    justify-content: center;
    align-items: center;
    color: #F00;
    background-color: #EEE;
    .redirect-button{
        border: none;
        outline: none;
        border-radius: 4px;
        margin: {
            left: auto;
            right: auto
        }
        padding: 10px
    }
}

</style>

<script>
export default {
    name: "PageNotFound",
    methods: {
        redirectToHomePage(){
            document.location.hash = '/'
        }
    }
}
</script>